import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/app/store/authStore';
import { VButton } from 'ah-common-lib/src/common/components';
import ShareIcon from 'ah-common-lib/src/icons/components/ShareIcon.vue';
import CopyIcon from 'ah-common-lib/src/icons/components/CopyIcon.vue';
import CheckMiniIcon from 'ah-common-lib/src/icons/components/CheckMiniIcon.vue';
import { useClipboard } from '@vueuse/core';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralButton',
  setup(__props) {

const BASE_URL = `${window.location.protocol}//${window.location.host}`;
const REFERRAL_PATH = '/referral';

const services = getServices();
const authStore = useAuthStore();
const requestManager = useRequestManager().manager;
const showReferralContainer = ref(false);
const referralContainerRef = ref<HTMLElement>();
const showCopiedPopover = ref(false);
const copyButton = ref<InstanceType<typeof VButton>>();
const referralLink = ref('');

const clientId = computed(() => authStore.loggedInIdentity?.client?.id);

const toggleReferralContainer = (event: Event) => {
  event.stopPropagation();
  showReferralContainer.value = !showReferralContainer.value;
  if (showReferralContainer.value && !referralLink.value) {
    getReferralLink();
  }
};

const closeReferralContainer = (event: MouseEvent) => {
  if (
    showReferralContainer.value &&
    referralContainerRef.value &&
    !referralContainerRef.value.contains(event.target as Node)
  ) {
    showReferralContainer.value = false;
  }
};

const { copy } = useClipboard();

const copyReferralLink = () => {
  copy(referralLink.value);
  showCopiedPopover.value = true;
  setTimeout(() => {
    showCopiedPopover.value = false;
  }, 2000);
};

const selectInputText = (event: Event) => {
  const input = event.target as HTMLInputElement;
  input.select();
};

function getReferralLink() {
  if (clientId.value) {
    requestManager
      .sameOrNew('loadReferralLink', services.registration.getClientReferralLink(clientId.value))
      .subscribe({
        next: (response) => {
          const { source, clientId: responseClientId, individualId } = response;
          const params = new URLSearchParams({
            source,
            clientId: responseClientId,
            individualId,
          });
          referralLink.value = `${BASE_URL}${REFERRAL_PATH}?${params.toString()}`;
        },
      });
  }
}

onMounted(() => {
  document.addEventListener('click', closeReferralContainer);
  getReferralLink();
});

onUnmounted(() => {
  document.removeEventListener('click', closeReferralContainer);
});

return { __sfc: true,BASE_URL, REFERRAL_PATH, services, authStore, requestManager, showReferralContainer, referralContainerRef, showCopiedPopover, copyButton, referralLink, clientId, toggleReferralContainer, closeReferralContainer, copy, copyReferralLink, selectInputText, getReferralLink, VButton, ShareIcon, CopyIcon, CheckMiniIcon }
}

})